<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row>
                <v-col
                    cols="12"
                    class="text-right"
                    v-if="
                        team_name != 'PSG' &&
                            team_name != 'BENCH RAMA3' &&
                            forms.status == 'SVC'
                    "
                >
                    <v-btn
                        :disabled="check_transfer"
                        rounded
                        small
                        color="primary"
                        @click="tranferBkk_scrap()"
                    >
                        <v-icon class="mr-1">mdi-truck-fast</v-icon>
                        Transfer to BKK
                    </v-btn>
                    <v-btn
                        :disabled="check_print"
                        rounded
                        small
                        class="ml-1 mr-1 indigo--text"
                        @click="gen_barcode()"
                    >
                        <v-icon color="light-blue darken-4 " class="mr-1">
                            mdi-barcode-scan
                        </v-icon>
                        Print Barcode
                    </v-btn>
                    <v-btn
                        :disabled="check_delete"
                        rounded
                        small
                        color="red lighten-1"
                        class="white--text"
                        @click="delete_scrap()"
                    >
                        <v-icon class="mr-1">mdi-delete-forever</v-icon>
                        Delete
                    </v-btn>
                </v-col>
                <v-col cols="12" class="text-right" v-else>
                    <v-btn
                        v-if="forms.status == 'Transfer'"
                        :disabled="checkbox.length == 0"
                        rounded
                        small
                        color="success"
                        class="ml-1 mr-1"
                        @click="received_bkk()"
                    >
                        <v-icon class="mr-1">
                            mdi-check
                        </v-icon>
                        Received
                    </v-btn>
                    <v-btn
                        v-if="forms.status == 'BKK'"
                        :disabled="checkbox.length == 0"
                        rounded
                        small
                        color="warning"
                        @click="send_scrap()"
                    >
                        <v-icon class="mr-1">mdi-truck-fast</v-icon>
                        Send Scrap
                    </v-btn>
                </v-col>
            </v-row>
            <!-- <v-row
                v-if="
                    team_name == 'PSG' ||
                        (team_name == 'BENCH RAMA3' &&
                            forms.status == 'Transfer')
                "
            >
                <v-col cols="8" md="4">
                    <v-text-field
                        rounded
                        outlined
                        dense
                        label="Scan Barcode"
                    ></v-text-field>
                </v-col>

                <v-col cols="3">
                    <v-btn
                        :disabled="checkbox.length == 0"
                        rounded
                        color="primary"
                        @click="tranferBkk_scrap()"
                    >
                        Receive
                    </v-btn>
                </v-col>
            </v-row> -->
            <v-row>
                <v-col cols="7">
                    <v-simple-table class="table-inv">
                        <template v-slot:default>
                            <thead>
                                <tr class="col-tr-1">
                                    <th class="text-center">
                                        #
                                    </th>
                                    <th class="text-center">
                                        Case
                                    </th>
                                    <th class="text-center">
                                        S/N
                                    </th>
                                    <th class="text-center">
                                        Scrap No
                                    </th>
                                    <th class="text-center">
                                        Box Size
                                    </th>
                                    <th class="text-center">
                                        Weight
                                    </th>
                                    <th class="text-center">
                                        <span
                                            v-if="
                                                team_name != 'PSG' &&
                                                    team_name !=
                                                        'BENCH RAMA3' &&
                                                    forms.status == 'SVC'
                                            "
                                        >
                                            Choose
                                        </span>
                                        <span v-else>
                                            <v-btn
                                                :color="colorx"
                                                rounded
                                                small
                                                @click="all()"
                                                class="ml-4"
                                            >
                                                All
                                            </v-btn>
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(row, index) in data_main"
                                    :key="index"
                                    :class="
                                        row.status == 'Request'
                                            ? 'amber lighten-3'
                                            : ''
                                    "
                                >
                                    <td class="text-center">
                                        {{ index + 1 }}.
                                    </td>
                                    <td>
                                        <span class="font-b primary--text">
                                            {{ row.case_id }}
                                        </span>
                                        <v-btn
                                            class="ml-2"
                                            dark
                                            :to="
                                                '/Project/ViewCasepending/' +
                                                    team_name +
                                                    '/' +
                                                    row.maincase_id +
                                                    '/ViewDetail'
                                            "
                                            target="_blank"
                                            x-small
                                            fab
                                            color="orange"
                                            elevation="1"
                                        >
                                            <v-icon small>mdi-magnify</v-icon>
                                        </v-btn>
                                        <br />
                                        <span class="font-b">
                                            {{ row.product_no }}
                                        </span>
                                        {{ row.product_description }}
                                    </td>
                                    <td>{{ row.serial }}</td>
                                    <td class="text-center">
                                        <span class="font-b primary--text">
                                            {{ row.branch_name }}
                                        </span>
                                        <br />
                                        {{ row.scrap_no }}
                                    </td>
                                    <td class="text-center">
                                        {{ row.box_size }}
                                    </td>
                                    <td class="text-right">
                                        {{ row.weight }}
                                    </td>
                                    <td class="text-center">
                                        <v-switch
                                            @change="checkbox_status"
                                            v-if="
                                                (team_name != 'PSG' &&
                                                    team_name !=
                                                        'BENCH RAMA3' &&
                                                    forms.status == 'SVC') ||
                                                    ((team_name == 'PSG' ||
                                                        team_name ==
                                                            'BENCH RAMA3') &&
                                                        forms.status !== 'SVC')
                                            "
                                            v-model="checkbox"
                                            :value="row.scrap_id"
                                        ></v-switch>
                                    </td>
                                </tr>
                                <br />
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
                <v-col cols="5">
                    <v-simple-table class="table-inv">
                        <template v-slot:default>
                            <thead>
                                <tr class="col-tr-1">
                                    <th class="text-center">
                                        #
                                    </th>
                                    <th class="text-center">
                                        Detail
                                    </th>
                                    <th class="text-center">
                                        Part No
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(row, index) in data_sub"
                                    :key="index"
                                    :class="
                                        row.return_remark == 'Request'
                                            ? 'amber lighten-3'
                                            : ''
                                    "
                                >
                                    <td class="text-center">
                                        {{ index + 1 }}.
                                    </td>
                                    <td>
                                        <span class="font-b primary--text">
                                            {{ row.branch_name }}
                                        </span>
                                        <br />
                                        <span class="font-b">
                                            {{ row.case_id }}
                                        </span>
                                        {{ row.site_name }}
                                    </td>
                                    <td>
                                        <span class="font-b">
                                            {{ row.part_name }}
                                        </span>
                                        {{ row.part_description }}
                                    </td>
                                </tr>
                                <br />
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <div id="printDiv">
            <div
                v-for="(row_barcode, index) in arr_barcode"
                :key="index"
                class="cols"
                style="padding: 0px; float: left; width: 50%;"
            >
                <table
                    width="100%"
                    border="1"
                    style="border-collapse: collapse !important;"
                    cellspacing="0"
                    cellpadding="0"
                >
                    <tr>
                        <td width="40%">
                            <span
                                style="font-weight: bold;padding:10px; font-size:20px;"
                            >
                                SCRAP
                            </span>
                        </td>
                        <td width="60%" colspan="2">
                            <span
                                style="font-weight: bold;padding:10px; font-size:20px;"
                            >
                                {{ row_barcode.scrap_no }}
                            </span>
                        </td>
                    </tr>

                    <tr>
                        <td width="40%">
                            <span style="font-weight: bold;padding:10px;">
                                {{ row_barcode.product_no }}
                            </span>
                        </td>
                        <td width="38%" rowspan="3" align="center">
                            <br />
                            <barcode
                                style="margin-top: 20px important;"
                                v-bind:value="row_barcode.scrap_no"
                                width="1"
                                height="70"
                                font-size="10"
                            >
                            </barcode>
                            <br />
                        </td>
                        <td width="22%" rowspan="3" align="center">
                            <qr-code
                                :text="row_barcode.scrap_no"
                                :size="70"
                                style="margin-right:15px;"
                            ></qr-code>
                        </td>
                    </tr>
                    <tr>
                        <td width="30%">
                            <span style="font-weight: bold;padding:10px;">
                                {{ "S/N : " + row_barcode.product_no }}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td width="30%">
                            <span style="font-weight: bold;padding:10px;">
                                {{ "Case : " + row_barcode.case_id }}
                            </span>
                        </td>
                    </tr>
                </table>

                <div
                    :class="
                        index + 1 != 1 && (index + 1) % 14 === 0
                            ? 'break-after'
                            : ''
                    "
                ></div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import VueBarcode from "vue-barcode"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    props: ["form"],
    components: {
        barcode: VueBarcode,
    },
    watch: {
        form: function(newQuestion, oldQuestion) {
            this.forms = this.form
            this.get_data()
        },
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.forms = this.form
        this.get_data()
    },
    methods: {
        checkbox_status() {
            this.check_print = true
            this.check_transfer = true
            this.check_delete = true
            let check_data = [...this.checkbox]
            if (check_data.length > 0) {
                // alert("check_data")
                this.check_print = false

                let status_transfer = false
                let status_delete = false

                this.data_main.map((row) => {
                    // alert(`${row}`)
                    if (check_data.indexOf(row.scrap_id) != -1) {
                        if (row.status == "Request") {
                            status_delete = true
                        }
                        if (row.status == "SVC") {
                            status_transfer = true
                        }
                    }
                })
                this.check_transfer = status_transfer
                this.check_delete = status_delete
            }
        },
        async get_data() {
            this.checkbox = []
            this.colorx = ""
            this.dialog_loading = true
            await axios
                .post(url + "scrap/view", this.forms, this.tk)
                .then((response) => {
                    this.checkbox = []
                    let checkboxes = []
                    this.dialog_loading = false
                    this.data_main = response.data.units
                    this.data_sub = response.data.parts

                    if (this.forms.status == "SVC") {
                        this.data_main.map((row) => {
                            if (row.status == "Request") {
                                checkboxes.push(row.scrap_id)
                            }
                        })
                    }
                    this.checkbox = [...checkboxes]
                    this.checkbox_status()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        scrapPage() {
            this.$emit("scrapPage")
        },
        delete_scrap() {
            this.$swal({
                title: "Delete this scrap ?",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    this.dialog_loading = true
                    let send = {
                        scrap_id: this.checkbox,
                    }
                    axios
                        .post(url + "scrap/delete", send, this.tk)
                        .then((response) => {
                            this.checkbox = []
                            this.dialog_loading = false
                            this.scrapPage()
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },
        tranferBkk_scrap() {
            this.$swal({
                title: "Transfer checked items to BKK ?",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    this.dialog_loading = true
                    let send = {
                        scrap_id: this.checkbox,
                        status: "Transfer",
                    }
                    axios
                        .post(url + "scrap/update-status", send, this.tk)
                        .then((response) => {
                            this.checkbox = []
                            this.dialog_loading = false
                            this.scrapPage()
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },
        received_bkk() {
            this.$swal({
                title: "Receive checked items to BKK ?",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    this.dialog_loading = true
                    let send = {
                        scrap_id: this.checkbox,
                        status: "Received",
                    }
                    axios
                        .post(url + "scrap/update-status", send, this.tk)
                        .then((response) => {
                            this.checkbox = []
                            this.dialog_loading = false
                            this.scrapPage()
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },
        send_scrap() {
            this.$swal({
                title: "Send checked items to Scrap ?",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    this.dialog_loading = true
                    let send = {
                        scrap_id: this.checkbox,
                        status: "Scrap",
                    }
                    axios
                        .post(url + "scrap/update-status", send, this.tk)
                        .then((response) => {
                            this.checkbox = []
                            this.dialog_loading = false
                            this.scrapPage()
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },
        gen_barcode() {
            this.dialog_loading = true
            this.arr_barcode = []
            this.data_main.map((each) => {
                if (this.checkbox.indexOf(each.scrap_id) >= 0) {
                    this.arr_barcode.push(each)
                }
            })

            const localOptions = {
                styles: [
                    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                    "https://aitt.netlify.app/barcode.css",
                ],
            }
            setTimeout(() => {
                this.dialog_loading = false
                this.$htmlToPaper("printDiv", localOptions, () => {})
            }, 1000)
        },
        all() {
            if (this.colorx == "") {
                this.colorx = "success"
                this.data_main.map((r) => {
                    this.checkbox.push(r.scrap_id)
                })
            } else {
                this.colorx = ""
                this.checkbox = []
            }
        },
    },

    data() {
        return {
            data_main: [],
            data_sub: [],
            dialog_loading: false,
            forms: {},
            team_name: localStorage.team_name,
            role_name: localStorage.role_name,
            checkbox: [],
            arr_barcode: [],
            check_transfer: true,
            check_print: true,
            check_delete: true,
            colorx: "",
        }
    },
}
</script>
<style scoped>
#printDiv {
    display: none;
}
</style>
